import { z } from 'zod';
import { SmartBuildAnswerSchema } from './SmartBuildAnswer';

export const SmartBuildAnswerMappingSchema = SmartBuildAnswerSchema.extend({
  expression: z.string().optional(),
  // If it ever happens to have multiple answers for the same question we will use the answer with higher priority to decide which one to pick.
  priority: z.number().optional(),
});

export type SmartBuildAnswerMapping = z.infer<typeof SmartBuildAnswerMappingSchema>;
